import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AiLabApiServiceImpl, AiLabApiService } from '@/infrastructure/api-functions/ai-lab-api-service';
import { GetTechKeyword } from '@/infrastructure/api-functions/interface/get-tech-keyword.interface';
import { CheckSensitiveWord } from '@/infrastructure/api-functions/interface/check-sensitive-word.interface';
import { GetQueryCount } from '@/infrastructure/api-functions/interface/get-query-count.interface';
import { InitAiLab } from '@/infrastructure/api-functions/interface/init-ai-lab.interface';
import { SetTechQuery } from '@/infrastructure/api-functions/interface/set-tech-query.interface';
import { GetPatentClms } from '@/infrastructure/api-functions/interface/get-patent-clms.interface';
import { GetMermaid } from '@/infrastructure/api-functions/interface/get-mermaid.interface';
import { AdviceApiServiceImpl, AdviceApiService } from '@/infrastructure/api-functions/advice-api.service';
import { SendAdvice } from '@/infrastructure/api-functions/interface/send-advice.interface';
import { TransferQuery } from '@/infrastructure/api-functions/interface/transfer-query.interface';
import { AiImageApiServiceImpl } from '@/infrastructure/api-functions/ai-image-api.service';
import { Image2Text, GetSemanticId } from '@/infrastructure/api-functions/interface/ai-image.interface';
import { GetTechArea } from '@/infrastructure/api-functions/interface/get-tech-area.interface';
import { GetTechSemantic } from '@/infrastructure/api-functions/interface/get-tech-semantic.interface';
import { GetRelatedIpc } from '@/infrastructure/api-functions/interface/get-related-ipc.interface';
import { GetClassificationDetail } from '@/infrastructure/api-functions/interface/get-classification-detail.interface';
import { CoreSearchApiServiceImpl, CoreSearchApiService } from '@/infrastructure/api-functions/core-search-api.service';
import { TranslationSync } from '@/infrastructure/api-functions/interface/translation-sync.interface';
import { TranslationOriginal } from '@/infrastructure/api-functions/interface/translation-original.interface';
import { GetTaskId } from '@/infrastructure/api-functions/interface/get-task-id.interface';
import { GetTechTopic } from '@/infrastructure/api-functions/interface/get-tech-topic.interface';
import { GetSuggestions } from '@/infrastructure/api-functions/interface/get-suggestions.interface';
import { AddTranslationAsyncTask } from '@/infrastructure/api-functions/interface/add-translation-async-task.interface';
import { GetTranslationAsyncStatus } from '@/infrastructure/api-functions/interface/get-translation-async-status.interface';
import { PutTranslationText } from '@/infrastructure/api-functions/interface/put-translation-text.interface';
import { ExportTranslation } from '@/infrastructure/api-functions/interface/export-translation.interface';
import { GetHistoryList } from '@/infrastructure/api-functions/interface/get-history-list.interface';
import { PutHistory } from '@/infrastructure/api-functions/interface/put-history.interface';
import { GetHistoryAsyncStatusList } from '@/infrastructure/api-functions/interface/get-history-async-status-list.interface';
import { GetHistoryDetail } from '@/infrastructure/api-functions/interface/get-history-detail.interface';
import { PutHistoryRead } from '@/infrastructure/api-functions/interface/put-history-read.interface';
import { GetTechMeans } from '@/infrastructure/api-functions/interface/get-tech-means.interface';
import { PutTechMeans } from '@/infrastructure/api-functions/interface/put-tech-means.interface';
import { GetDisclosureTitle } from '@/infrastructure/api-functions/interface/get-disclosure-title.interface';
import { GetDisclosureContent } from '@/infrastructure/api-functions/interface/get-disclosure-content.interface';
import { PutDisclosureSetting } from '@/infrastructure/api-functions/interface/put-disclosure-setting.interface';
import { ExportDisclosure } from '@/infrastructure/api-functions/interface/export-disclosure.interface';

export const serviceApiModule = new ContainerModule((bind) => {
    bind(AiLabApiService).to(AiLabApiServiceImpl);
    bind(GetTechKeyword).to(AiLabApiServiceImpl);
    bind(CheckSensitiveWord).to(AiLabApiServiceImpl);
    bind(GetQueryCount).to(AiLabApiServiceImpl);
    bind(InitAiLab).to(AiLabApiServiceImpl);
    bind(SetTechQuery).to(AiLabApiServiceImpl);
    bind(GetPatentClms).to(AiLabApiServiceImpl);
    bind(GetMermaid).to(AiLabApiServiceImpl);
    bind(GetTechArea).to(AiLabApiServiceImpl);
    bind(GetTechSemantic).to(AiLabApiServiceImpl);
    bind(GetClassificationDetail).to(AiLabApiServiceImpl);
    bind(AdviceApiService).to(AdviceApiServiceImpl);
    bind(SendAdvice).to(AdviceApiServiceImpl);
    bind(Image2Text).to(AiImageApiServiceImpl);
    bind(GetSemanticId).to(AiImageApiServiceImpl);
    bind(GetRelatedIpc).to(AiLabApiServiceImpl);
    bind(CoreSearchApiService).to(CoreSearchApiServiceImpl);
    bind(TransferQuery).to(CoreSearchApiServiceImpl);
    bind(TranslationSync).to(CoreSearchApiServiceImpl);
    bind(TranslationOriginal).to(CoreSearchApiServiceImpl);
    bind(GetTaskId).to(CoreSearchApiServiceImpl);
    bind(GetHistoryList).to(CoreSearchApiServiceImpl);
    bind(PutHistory).to(CoreSearchApiServiceImpl);
    bind(GetHistoryAsyncStatusList).to(CoreSearchApiServiceImpl);
    bind(GetHistoryDetail).to(CoreSearchApiServiceImpl);
    bind(PutHistoryRead).to(CoreSearchApiServiceImpl);
    bind(GetTechTopic).to(CoreSearchApiServiceImpl);
    bind(GetSuggestions).to(CoreSearchApiServiceImpl);
    bind(AddTranslationAsyncTask).to(CoreSearchApiServiceImpl);
    bind(GetTranslationAsyncStatus).to(CoreSearchApiServiceImpl);
    bind(PutTranslationText).to(CoreSearchApiServiceImpl);
    bind(ExportTranslation).to(CoreSearchApiServiceImpl);
    bind(GetTechMeans).to(CoreSearchApiServiceImpl);
    bind(PutTechMeans).to(CoreSearchApiServiceImpl);
    bind(GetDisclosureTitle).to(CoreSearchApiServiceImpl);
    bind(GetDisclosureContent).to(CoreSearchApiServiceImpl);
    bind(PutDisclosureSetting).to(CoreSearchApiServiceImpl);
    bind(ExportDisclosure).to(CoreSearchApiServiceImpl);
});
